<template>
  <div>
    <b-table
      :busy="isBusy"
      class="tab-b"
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      :items="listSkusProducts"
      :fields="fields"
      @row-selected="onRowSelected"
      responsive="sm"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import axios from 'axios'
import { mapState } from "vuex";
export default {
  name: "ModalSkuProducts",
  data() {
    return {
      fields: [
        { key: "selected", label: "" },
        { key: "sku", label: " Sku" },
        { key: "description", label: " Descripción" },
      ],
      selectMode: "single",
      isBusy:false,
      listSkusProducts:[]

    };
  },
  computed:{

    ...mapState("module", ["username","token"]),
  },

  created() {
    this.getListSkuProduct()
  },
  methods: {
    onRowSelected(items) {
      this.$emit("rowSkuSelected", items);
      this.$root.$emit("bv::hide::modal", "modal-product");
    },
    async getListSkuProduct() {
      try {
        this.isBusy = true;
        let response = await axios.get(
          process.env.VUE_APP_SERVICES_CORE_BASE +
            "/products?limit=10&page=1&pageable=true",
            {
              headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer "+ this.token
                }
            }
        );
        const data = response.data.map((user) => {
          return {
            sku: user.sku,
            description: user.description,
            services: user.services.map((row) => {
              return {
                sku: row.sku,
                description: row.description,
              };
            }),
          };
        });
        this.listSkusProducts = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
<style scoped>
.btn-secondary:not(:disabled):not(.disabled):active {
  border-color: transparent !important;
}
.btn-secondary:focus,
.btn-secondary.focus {
  border-color: transparent !important;
}
.btn-secondary {
  border: none !important;
}

.bg-red {
  background: #ff4c4c;
}
.color-white {
  color: white;
}
.width-10 {
  width: 21px;
  height: 23px;
  text-align: center;
}
.border-gray {
  border: 1px solid gray;
}
.bg-white {
  background: white;
  border-color: gray;
}
.bg-orange {
  background: rgb(254, 123, 1) !important;
}
.text-center {
  text-align: center;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
.btn-secondary:not(:disabled):not(.disabled):active {
  border-color: transparent !important;
}
.btn-secondary:focus,
.btn-secondary.focus {
  border-color: transparent !important;
}
</style>
